import { SiteFrame, ButtonLink } from '../components/Shell';
import { NetlifyForm, validators, type FieldDef } from '../components/Form';
import { useContent } from '../siteContent';

const activationFields = (branchOptions: string[]): FieldDef[] => [
  { name: 'restaurant', label: 'اسم المطعم', required: true, autoComplete: 'organization' },
  { name: 'contact_name', label: 'اسم المسؤول', required: true, autoComplete: 'name' },
  { name: 'phone', label: 'رقم الجوال', type: 'tel', required: true, inputMode: 'tel', autoComplete: 'tel', placeholder: '05XXXXXXXX', validate: validators.saudiMobile },
  { name: 'email', label: 'البريد الإلكتروني', type: 'email', optional: true, inputMode: 'email', autoComplete: 'email', placeholder: 'name@restaurant.sa', validate: validators.email },
  { name: 'city', label: 'المدينة', required: true, autoComplete: 'address-level2' },
  { name: 'branches', label: 'عدد الفروع', type: 'select', required: true, options: branchOptions },
  { name: 'notes', label: 'ملاحظات', type: 'textarea', optional: true, placeholder: 'مثل: عدد المشتركين الحالي، أو كيف تدير الاشتراكات اليوم', maxLength: 1000 },
];

export function GetStartedPage() {
  const { getStarted, pricing } = useContent();
  return <SiteFrame page="get-started">
    <section className="mx-page mx-container mx-request" aria-labelledby="request-title">
      <div className="mx-request-copy">
        <h1 id="request-title" className="mx-h1">{getStarted.title}</h1>
        <p className="mx-lead">{getStarted.lead}</p>
        <ol className="mx-next">{getStarted.steps.map((item, index) => <li key={index}><span aria-hidden="true">{index + 1}</span><div><h2>{item.title}</h2><p>{item.text}</p></div></li>)}</ol>
        <div className="mx-request-price">
          <p><b>{pricing.price}</b> {pricing.period} {pricing.unit}</p>
          {pricing.setupFee && <p>{pricing.setupLabel} <b>{pricing.setupFee}</b></p>}
          {pricing.fineprint && <small>{pricing.fineprint}</small>}
        </div>
      </div>
      <div className="mx-request-form">
        <NetlifyForm name="activation" fields={activationFields(getStarted.branchOptions)} submitLabel={getStarted.submitLabel}
          privacyNote={<>{getStarted.privacyNote}، اقرأ <a href="/privacy">سياسة الخصوصية</a></>}
          success={<><h2 className="mx-h3">{getStarted.successTitle}</h2><p className="mx-body">{getStarted.successText}</p><ButtonLink href="/" variant="quiet">العودة إلى الصفحة الرئيسية</ButtonLink></>} />
      </div>
    </section>
  </SiteFrame>;
}
